module.exports = __webpack_public_path__ + "5517d73acdc17143c21b0cffab4cfaa9.ttf";